import { render, staticRenderFns } from "./gameResultRescueTab.vue?vue&type=template&id=15258bf1&lang=pug"
import script from "./gameResultRescueTab.vue?vue&type=script&lang=js"
export * from "./gameResultRescueTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports